import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Tecla de teclado (keycap). Uso: <app-kbd>Esc</app-kbd> o <app-kbd>⌘</app-kbd>.
 * Presentacional: proyecta su contenido dentro de un <kbd> estilizado.
 */
@Component({
  selector: 'app-kbd',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<kbd class="kbd"><ng-content></ng-content></kbd>',
  styleUrl: './kbd.component.scss',
})
export class KbdComponent {}
